export default "__VITE_ASSET__BES7dREF__"